<template>
  <Chart
    type="doughnut"
    :width="width"
    :height="height"
    :data="data"
    :options="options"
    :plugins="[stackedText]"
  />
</template>

<script>
import { defineComponent, computed, reactive } from "vue";
import { useStore } from "@/store";
import {millionShortNum, millionShortString} from "@/utils/format-number"

export default defineComponent({
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    chartLabel:{
      type: Array,
      default: ()=>[]
    },
    seriesData:{
      type: Array,
      default: ()=> []
    },
    totalData:{
      type: Number,
      default: 0
    },
    layout:{
      type: Object,
      default: ()=>{}
    },
    paddingLayout: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const store = useStore();
    const darkMode = computed(() => store.state.main.darkMode);
    const data = computed(() => {
      return {
        labels: props.chartLabel,
        datasets: [
          {
            data: props.seriesData,
            backgroundColor: ["#41b981", "#4294b9", "#df9090", "#fea960"],
            hoverBackgroundColor: ["#41b981", "#4294b9", "#df9090", "#fea960"],
            borderWidth: 3,
            // borderColor: darkMode.value ? "#303953" : "#fff",
          },
        ],
      };
    });
    const stackedText = computed(()=>{
      return {
        id: "stackedText",
        afterDatasetsDraw(chart, args, options){
          const {ctx, chartArea:{top, bottom, left, right}, width, height} = chart
          let fontWidth = width
          if(fontWidth > 700 && fontWidth < 2500)
            fontWidth = 700
          ctx.save()
          ctx.font = `bolder ${(fontWidth*50)/100}% Kanit`;
          ctx.fillStyle = `${props.totalData >= 0 ? '#41b882' : '#FF6384'}`;
          ctx.textAlign = "center";
          if(props.paddingLayout){
            ctx.fillText(`คงเหลือ`, width/2 - props.paddingLayout, (height-35)/2) //for fam
          }
          else{
             ctx.fillText(`คงเหลือ`, (width - 130)/2, (height-35)/2)
          }
          ctx.restore();
          ctx.font = `bolder ${(fontWidth*50)/100}% Kanit`;
          ctx.fillStyle = `${props.totalData >= 0 ? '#41b882' : '#FF6384'}`;
          ctx.textAlign = "center";
          if(props.paddingLayout){
            ctx.fillText(`${millionShortNum(props.totalData)}${millionShortString(props.totalData)}`, width/2 - props.paddingLayout, height/2 + ((fontWidth*50)/100)/10) //for fam
          }
          else{
            ctx.fillText(`${millionShortNum(props.totalData)}${millionShortString(props.totalData)}`, (width - 130)/2 , height/2 + ((fontWidth*50)/100)/10) //+25
          }


          // ctx.fillStyle = "#000";
          // // (xStart, yStart, width, height)
          // // ctx.fillRect(width/2,top,1, bottom)
          // ctx.fillRect((width-130)/2,top,1, bottom)
          // ctx.fillRect(left, height/2, right, 1)
        }
      }
    })
    const options = computed(() => {
      return {
        layout:props.layout,
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              return data['labels'][tooltipItem[0]['index']];
            },
            label: function(tooltipItem, data) {
              return new Intl.NumberFormat().format(data['datasets'][0]['data'][tooltipItem['index']]);
            },
          }
        },
        cutoutPercentage: 80,
        /* elements: {
          center: {
            text: `คงเหลือ. ${new Intl.NumberFormat().format(props.totalData)} บาท`,
            color: `${props.totalData >= 0 ? '#41b882' : '#FF6384'}`, // Default is #000000
            fontStyle: 'Kanit', // Default is Arial
            sidePadding: 20, // Default is 20 (as a percentage)
            minFontSize: 11, // Default is 20 (in px), set to false and text will not wrap.
            lineHeight: 30 // Default is 25 (in px), used for when text wraps
          }
        }, */
        legend: {
          position: "right",
          labels: {
            pointStyle: "circle",
            usePointStyle: true,
            generateLabels(chart) {
              var data = chart.data;
              if (data.labels.length && data.datasets.length) {
                return data.labels.map(function(label, i) {
                  var meta = chart.getDatasetMeta(0);
                  var ds = data.datasets[0];
                  var arc = meta.data[i];
                  var custom = (arc && arc.custom) || {};
                  var getValueAtIndexOrDefault =
                    Chart.helpers.getValueAtIndexOrDefault;
                  var arcOpts = chart.options.elements.arc;
                  var fill = custom.backgroundColor
                    ? custom.backgroundColor
                    : getValueAtIndexOrDefault(
                        ds.backgroundColor,
                        i,
                        arcOpts.backgroundColor
                      );
                  var stroke = custom.borderColor
                    ? custom.borderColor
                    : getValueAtIndexOrDefault(
                        ds.borderColor,
                        i,
                        arcOpts.borderColor
                      );
                  var bw = custom.borderWidth
                    ? custom.borderWidth
                    : getValueAtIndexOrDefault(
                        ds.borderWidth,
                        i,
                        arcOpts.borderWidth
                      );

                  // We get the value of the current label
                  var value =
                    chart.config.data.datasets[arc._datasetIndex].data[
                      arc._index
                    ];

                  return {
                    // Instead of `text: label,`
                    // We add the value to the string
                    text: `${label}: ${new Intl.NumberFormat().format(value)} บาท`,
                    fillStyle: fill,
                    strokeStyle: stroke,
                    lineWidth: bw,
                    hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                    index: i,
                  };
                });
              } else {
                return [];
              }
            },
          },
        },
        responsive:true,
      };
    });
    // options.plugins.legend;

    return {
      data,
      options,
      stackedText
    };
  },
});
</script>
